import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';

const categories = ['ALL', 'セントマーケティング', '空間演出', 'ブランディング', 'トレンド'];

const columns = [
  {
    id: 1,
    category: 'セントマーケティング',
    date: '2026.03.28',
    title: '香りがブランドを作る——セントマーケティングの基礎知識',
    excerpt: '視覚・聴覚に次ぐ「第三の感覚」として注目される嗅覚マーケティング。なぜ香りがブランドの記憶定着に効果的なのか、その科学的根拠と実践事例を解説します。',
    image: 'https://public.readdy.ai/ai/img_res/32be984d91a4170ee4ebc95e9d91f8c9.jpg',
    readTime: '5 min',
  },
  {
    id: 2,
    category: '空間演出',
    date: '2026.03.20',
    title: 'ホテルロビーの香り設計——五感で魅せるおもてなし',
    excerpt: '一流ホテルが香りに投資する理由とは？チェックインの瞬間から始まる香りの演出が、ゲストの満足度とリピート率にどう影響するかを事例とともに紹介します。',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20hotel%20lobby%20interior%20with%20warm%20ambient%20lighting%2C%20elegant%20floral%20arrangement%2C%20marble%20floors%20and%20sophisticated%20decor%2C%20high-end%20hospitality%20atmosphere%2C%20soft%20beige%20and%20gold%20tones&width=800&height=500&seq=col2&orientation=landscape',
    readTime: '6 min',
  },
  {
    id: 3,
    category: 'ブランディング',
    date: '2026.03.12',
    title: 'オリジナルフレグランスで差別化——ブランド香りの作り方',
    excerpt: '「うちのブランドの香り」を持つことが、今や高級ブランドだけの話ではなくなっています。中小企業でも実現できるオリジナルフレグランス開発のプロセスを公開。',
    image: 'https://readdy.ai/api/search-image?query=artisan%20fragrance%20creation%20process%20with%20glass%20bottles%20of%20essential%20oils%20and%20botanical%20ingredients%20on%20wooden%20table%2C%20warm%20studio%20lighting%2C%20craft%20perfumery%20aesthetic%2C%20earthy%20natural%20tones&width=800&height=500&seq=col3&orientation=landscape',
    readTime: '7 min',
  },
  {
    id: 4,
    category: 'トレンド',
    date: '2026.03.05',
    title: '2026年の香りトレンド——ウェルネスとサステナビリティ',
    excerpt: 'コロナ禍を経て「癒し」と「自然」への回帰が加速。今年注目されるフレグランストレンドと、それをビジネスに活かすヒントをお届けします。',
    image: 'https://readdy.ai/api/search-image?query=sustainable%20natural%20botanical%20ingredients%20for%20eco-friendly%20fragrance%2C%20green%20herbs%20and%20flowers%20on%20linen%20fabric%2C%20wellness%20and%20nature%20concept%2C%20soft%20daylight%2C%20muted%20green%20and%20cream%20palette&width=800&height=500&seq=col4&orientation=landscape',
    readTime: '4 min',
  },
  {
    id: 5,
    category: 'セントマーケティング',
    date: '2026.02.25',
    title: '小売店舗における香りの効果——購買行動への影響',
    excerpt: '香りが顧客の滞在時間や購買意欲に与える影響を、実際の実験データをもとに解説。アパレル・食品・コスメ各業種での活用事例も紹介します。',
    image: 'https://readdy.ai/api/search-image?query=modern%20minimalist%20retail%20store%20interior%20with%20elegant%20product%20display%2C%20warm%20accent%20lighting%2C%20clean%20white%20walls%20and%20wooden%20shelving%2C%20upscale%20shopping%20atmosphere%2C%20neutral%20beige%20tones&width=800&height=500&seq=col5&orientation=landscape',
    readTime: '6 min',
  },
  {
    id: 6,
    category: '空間演出',
    date: '2026.02.15',
    title: 'オフィスに香りを取り入れる——生産性と集中力への効果',
    excerpt: 'ワークプレイスに香りを導入する企業が増えています。集中力を高めるシトラス系、リラックスを促すラベンダー系など、目的別の香り選びと導入事例を解説。',
    image: 'https://readdy.ai/api/search-image?query=contemporary%20office%20workspace%20with%20natural%20light%2C%20green%20plants%2C%20clean%20desk%20setup%20and%20calm%20productive%20atmosphere%2C%20Scandinavian%20minimalist%20interior%20design%2C%20white%20and%20light%20wood%20tones&width=800&height=500&seq=col6&orientation=landscape',
    readTime: '5 min',
  },
];

export default function ColumnPage() {
  const [activeCategory, setActiveCategory] = useState('ALL');
  const navigate = useNavigate();

  const filtered = activeCategory === 'ALL'
    ? columns
    : columns.filter((c) => c.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <span className="inline-flex items-center border border-stone-400 text-stone-500 text-xs tracking-widest px-4 py-1.5 rounded-full w-fit mb-6">
            COLUMN
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-stone-900 tracking-wide leading-tight">
            コラム
          </h1>
          <p className="mt-4 text-stone-500 text-sm leading-relaxed max-w-xl">
            香りとビジネスに関する最新情報、事例、トレンドをお届けします。
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="sticky top-16 md:top-20 z-40 bg-white border-b border-stone-100">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="flex items-center gap-1 overflow-x-auto py-4 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`whitespace-nowrap text-xs tracking-widest px-5 py-2 rounded-full transition-all duration-300 cursor-pointer ${
                  activeCategory === cat
                    ? 'bg-stone-900 text-white'
                    : 'text-stone-500 hover:text-stone-900 hover:bg-stone-100'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Column Grid */}
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          {/* Featured (first article) */}
          {activeCategory === 'ALL' && filtered.length > 0 && (
            <div
              className="mb-16 group cursor-pointer"
              onClick={() => navigate(`/column/${filtered[0].id}`)}
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
                <div className="overflow-hidden rounded-lg w-full h-[280px] md:h-[360px]">
                  <img
                    src={filtered[0].image}
                    alt={filtered[0].title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="flex flex-col gap-4">
                  <div className="flex items-center gap-3">
                    <span className="text-xs tracking-widest text-stone-400 border border-stone-300 px-3 py-1 rounded-full">
                      {filtered[0].category}
                    </span>
                    <span className="text-xs text-stone-400">{filtered[0].date}</span>
                    <span className="text-xs text-stone-400">{filtered[0].readTime} read</span>
                  </div>
                  <h2 className="text-2xl md:text-3xl font-light text-stone-900 leading-snug tracking-wide group-hover:text-stone-600 transition-colors duration-300">
                    {filtered[0].title}
                  </h2>
                  <p className="text-stone-500 text-sm leading-relaxed">
                    {filtered[0].excerpt}
                  </p>
                  <span className="inline-flex items-center gap-2 text-xs tracking-widest text-stone-700 mt-2 group-hover:gap-3 transition-all duration-300">
                    続きを読む <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
            {(activeCategory === 'ALL' ? filtered.slice(1) : filtered).map((col) => (
              <article
                key={col.id}
                className="group cursor-pointer flex flex-col gap-4"
                onClick={() => navigate(`/column/${col.id}`)}
              >
                <div className="overflow-hidden rounded-lg w-full h-[200px] md:h-[220px]">
                  <img
                    src={col.image}
                    alt={col.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs tracking-widest text-stone-400 border border-stone-200 px-3 py-1 rounded-full">
                    {col.category}
                  </span>
                  <span className="text-xs text-stone-400">{col.date}</span>
                </div>
                <h3 className="text-base font-light text-stone-900 leading-snug tracking-wide group-hover:text-stone-600 transition-colors duration-300">
                  {col.title}
                </h3>
                <p className="text-stone-500 text-xs leading-relaxed line-clamp-3">
                  {col.excerpt}
                </p>
                <span className="inline-flex items-center gap-2 text-xs tracking-widest text-stone-600 group-hover:gap-3 transition-all duration-300">
                  続きを読む <i className="ri-arrow-right-line" />
                </span>
              </article>
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="text-center py-24 text-stone-400 text-sm tracking-widest">
              該当するコラムがありません
            </div>
          )}
        </div>
      </section>

      {/* Back to Home */}
      <section className="py-12 md:py-16 border-t border-stone-100">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-stone-600 text-sm tracking-widest hover:text-stone-900 transition-colors duration-300 cursor-pointer"
          >
            <i className="ri-arrow-left-line" />
            トップページに戻る
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
